export const JourneyBreakpoint = {
    300: {
        slidesPerView: 1,
        spaceBetween: 24,
        resistanceRatio: 0.85
    },
    480: { 
        slidesPerView: 1,
        spaceBetween: 1,
        resistanceRatio: 0.85
    },
    600: {
        slidesPerView: 1,
        spaceBetween: 20,
        resistanceRatio: 0.85,
        loop: true
    },
    768: {
        slidesPerView: 1,
        spaceBetween: 20,
        resistanceRatio: 0.85,
        loop: true
    },
    1024: {
        slidesPerView: 2,
        resistanceRatio: 0,
        spaceBetween: 50,
        resistanceRatio: 0.85
    }
};

export const reelBreakpoint = {
    300: {
        slidesPerView: 1,
        spaceBetween: 24,
        resistanceRatio: 0.85,
        loop: true
    },
    480: { 
        slidesPerView: 1,
        spaceBetween: 1,
        resistanceRatio: 0.85,
        loop: true
    },
    600: {
        slidesPerView: 1,
        spaceBetween: 20,
        resistanceRatio: 0.85,
        loop: true
    },
    768: {
        slidesPerView: 2,
        spaceBetween: 20,
        resistanceRatio: 0.85,
        loop: true
    },
    1024: {
        slidesPerView: 3,
        spaceBetween: 10,
        resistanceRatio: 0.85,
        loop: true
    },
    1280: {
        slidesPerView: 4,
        spaceBetween: 10,
        resistanceRatio: 0.85,
        loop: true
    },
    1600: {
        slidesPerView: 5,
        spaceBetween: 10,
        resistanceRatio: 0.85,
        loop: true
    }
};

export const AboutCertification = {
    300: {
        slidesPerView: 2,
        spaceBetween: 15,
    },
    400: {
        slidesPerView: 2,
        spaceBetween: 15,
    },
    768: {
        slidesPerView: 3,
        spaceBetween: 30,
    },
    980: {
        slidesPerView: 4,
        spaceBetween: 80,
    },
    1280: {
        slidesPerView: 5,
        spaceBetween: 50,
    },
    1600: {
        slidesPerView: 5,
        spaceBetween: 50,
    }
};

export const RelProduct = {
    300: {
        slidesPerView: 2,
        spaceBetween: 45,
    },
    400: {
        slidesPerView: 2,
        spaceBetween: 45,
    },
    768: {
        slidesPerView: 3,
        spaceBetween: 45,
    },
    980: {
        slidesPerView: 3,
        spaceBetween: 45,
    },
    1280: {
        slidesPerView: 4,
        spaceBetween: 45,
    },
    1600: {
        slidesPerView: 4,
        spaceBetween: 45,
    }
}

export const otherCatSlider = {
    300: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      400: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      980: {
        slidesPerView: 4,
        spaceBetween: 80,
      },
      1280: {
        slidesPerView: 5,
        spaceBetween: 100,
      },
      1600: {
        slidesPerView: 5,
        spaceBetween: 100,
      }
}

export const ProductTestVid = {
    300: {
        slidesPerView: 2,
        spaceBetween: 15,
        resistanceRatio: 0.85,
        loop: true
    },
    480: { 
        slidesPerView: 2,
        spaceBetween: 15,
        resistanceRatio: 0.85,
        loop: true
    },
    600: {
        slidesPerView: 1,
        spaceBetween: 20,
        resistanceRatio: 0.85,
        loop: true
    },
    768: {
        slidesPerView: 3,
        spaceBetween: 30,
        resistanceRatio: 0.85,
        loop: true
    },
    1024: {
        slidesPerView: 4,
        spaceBetween: 40,
        resistanceRatio: 0.85,
        loop: true
    },
    1280: {
        slidesPerView: 4,
        spaceBetween: 40,
        resistanceRatio: 0.85,
        loop: true
    },
    1600: {
        slidesPerView: 4,
        spaceBetween: 40,
        resistanceRatio: 0.85,
        loop: true
    }
}

